"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const body_scroll_lock_1 = require("body-scroll-lock");
const React = __importStar(require("react"));
const ModalStyle_1 = require("./ModalStyle");
const helper_1 = require("./helper");
class Modal extends React.Component {
    constructor() {
        super(...arguments);
        this.targetElement = null;
    }
    componentDidMount() {
        const style = document.createElement("style");
        style.id = "enable-scroll-style";
        style.innerHTML = `
      .focus-element {
        outline: 0;
      }
    `;
        document.head.appendChild(style);
        helper_1.disableScroll();
        const focusElement = document.getElementsByClassName("focus-element")[0];
        if (this.props.closeable && focusElement) {
            helper_1.setOuterAsClosable(focusElement);
        }
    }
    componentWillUnmount() {
        const style = document.getElementById("enable-scroll-style");
        if (style)
            document.head.removeChild(style);
        body_scroll_lock_1.clearAllBodyScrollLocks();
    }
    render() {
        return (React.createElement("div", { id: "shpID-lightbox-content", style: ModalStyle_1.lightboxStyle },
            React.createElement("div", { style: ModalStyle_1.overlay }),
            React.createElement("div", { id: "spid-lightbox-overlay", style: ModalStyle_1.overlayFull },
                React.createElement("div", { id: "modal-content", style: ModalStyle_1.sectionStyle }, this.props.body))));
    }
}
exports.default = Modal;
//# sourceMappingURL=Modal.js.map